import { ArcElement, Chart as ChartJS, Legend, Tooltip } from 'chart.js'
import { useMetadataUser } from 'contexts/metadata-user-context'
import { Doughnut } from 'react-chartjs-2'
import {
  ResponseStatusEmployee,
  traduzirStatus,
} from 'services/fetch-employees-by-status'

ChartJS.register(ArcElement, Tooltip, Legend)

interface ChartStatusProps {
  employees: ResponseStatusEmployee[]
}

export default function ChartStatus({ employees }: Readonly<ChartStatusProps>) {
  const { darkMode } = useMetadataUser()

  const data = {
    labels: employees?.map((data: ResponseStatusEmployee) =>
      traduzirStatus(data.status),
    ),
    datasets: [
      {
        label: 'Número de funcionários',
        data: employees?.map((data: ResponseStatusEmployee) => data.percentage),
        backgroundColor: [
          'rgba(241, 74, 22)', // red
          'rgba(252, 153, 24)', // yellow
          'rgba(136, 189, 61)', // green
        ],
        borderColor: [
          'rgba(241, 74, 22, 0.2)', // red
          'rgba(252, 153, 24, 0.2)', // yellow
          'rgba(136, 189, 61, 0.2)', // green
        ],
        borderWidth: 2,
      },
    ],
  }

  const options = {
    plugins: {
      legend: {
        labels: {
          color: !darkMode ? '#000000' : '#FFFFFF',
          padding: 10,
          font: {
            size: 15,
          },
        },
      },
      tooltip: {
        callbacks: {
          label: function (context: any) {
            let label = context.label || ''
            if (label) {
              label += ': '
            }
            label += `${context.raw}%`
            label += ` que representa ${employees[context.dataIndex].count} colaboradores`
            return label
          },
        },
      },
    },
  }

  return (
    <section className="bg-[#F9FAFB] w-1/3 min-w-[480px] dark:bg-[#1F2937] rounded-3xl flex flex-col items-center p-5 gap-10">
      <span className="text-[#000000] dark:text-[#ffffff] font-bold text-3xl">
        Colaboradores por status
      </span>
      <div className="w-[380px] h-auto">
        {data.labels.length > 0 ? (
          <Doughnut data={data} options={options} />
        ) : (
          <div className="flex flex-col items-center gap-2">
            <span className="text-[#000000] dark:text-[#ffffff] font-bold text-2xl">
              Não há dados suficientes
            </span>
            <span className="text-[#000000] dark:text-[#ffffff] font-bold text-2xl">
              para exibir o gráfico
            </span>
          </div>
        )}
      </div>
    </section>
  )
}
